rdefine("app/clients/Module",['backbone',
        'text!clients/module.html',
        'app/components/SelectOption',
        'app/clients/LanguageForm',
        'app/components/SelectPicker',
        'app/clients/ConfigureMessageTab',
        'app/components/TableBJS',
        'app/clients/PropertyModal',
        'text!clients/tablerowprofile.html'],
    function(Backbone, template, SelectOption, LanguageForm, SelectPicker, ConfigureMessageTab, TableBJS, PropertyModal, TableRowTemplate) {
    var vords = 0;
        var DataRowBindings = {
            '.name':{
                text:{
                    data:'model.name',
                    processor: function(langname) {
                        return langname && langname[CURRENT_LOCALE] ? langname[CURRENT_LOCALE] : '-';
                    }
                }
            },
            '.visiblediv input':{
                checked:{
                    data:'model.visible'
                }
            },
            '.inlistdiv input':{
                checked:{
                    data:'model.show_profile_list'
                }
            },
            el:{
                attr:{
                    'data-id':{
                        data:['model.id','model.cid'],
                        processor: function(id,cid) {
                            if(id) {
                                return id;
                            }
                            return cid;
                        }
                    }
                },
                classes:{
                    'child-lit':{
                        data:'model.parent_id',
                        processor:function(parent_id) {
                            return parent_id ? '30px' : 0;
                        }
                    }
                }
            }
        };

        var DumbTableRow = Backbone.Ribs.View.extend({
            tagName:'li',
            className:'st-row',
            bindings:{},
            events:{
            },
            cmodel:null,
            initialize:function() {
                this.preventBindings();
                this.$el.html(Template7.compile(TableRowTemplate)({order:vords++}));
                this.bindings = _.clone(DataRowBindings);

                this.addBindings(this.bindings);
            }
        });

        var propertyModel = Backbone.Ribs.Model.extend({
            defaults:{
                id:0,
                type:'string',
                names:{},
                required:false,
                visible:true,
                options:[],
                icon:''
            },
            reset:function() {
                this.set(this.defaults);
            }
        });

        return Backbone.Ribs.View.extend({
            tagName:'div',
            className:'clients-configurator-wrap',
            bindings:{

                ".cancel-button":{
                    attr:{
                        href:{
                            data:'opts.backurl'
                        }
                    }
                },
                '.props-table-place-list .super-table-rows':{
                    collection:{
                        col:'props',
                        view:DumbTableRow
                    }
                },
            },
            events:{
                "click .action-button":"doAction"
            },
            config_login_field_type:null,
            props:[],
            handlers:{
                customselect:{
                    get: function ($el, value) {
                        $el.trigger('change');
                        if ($el.val() !== value) {
                            $el.find("option[selected]").removeAttr("selected");
                            $el.find("option[value="+value+"]").attr("selected","selected");
                            $el.val(value);
                        }
                        $el.selectpicker('refresh');
                    },
                    set: function ($el) {
                        $el.selectpicker('refresh');
                        return $el.val();
                    }
                },
                valueCustom: {
                    get: function ($el, value) {
                        if ($el.val() !== value) {
                            $el.val(value).trigger('change');
                            $el[0].fpp.refreshPicker();
                        }
                    },
                    set: function ($el) {
                        return $el.val();
                    }
                }
            },
            initialize:function(options) {
                document.addEventListener('wheel', this.processScroll.bind(this), {
                    capture: true,
                    passive: true
                });
                this.orders =0 ;
                this.$el.html(Template7.compile(template)());
                this.$el.find('[data-toggle="tooltip"]').tooltip();

                //modal
                this.modal = new Backbone.Ribs.Model({
                    title:'',
                    action:'',
                    enabled: false,
                    auto_login:false
                });

                this.opts=new Backbone.Ribs.Model(options);
                this.languages = new Backbone.Ribs.Collection(options.languages, { model:Backbone.Ribs.Model});
                this.props = new Backbone.Ribs.Collection(options.model, { model: propertyModel });
                this.props.languages = this.languages;
                this.opts.set('plen', this.props.length);

                this.pmodel = new propertyModel();

                this.$el.removeClass("loading");
                initFontPicker();
                var adjustment = 0;
                var cheight = 0;
                //add sorting
                this.$el.find(".props-table-place-list .super-table-rows").sortable({
                    //group: 'prop-drag-drop',
                    //pullPlaceholder: true,
                    handle: ".drag",
                    //placeholder:"list-group-item media super-menu-drag higlight",
                    // animation on drop
                    itemSelector:'li.st-row',
                    onDrop: function  ($item, container, _super) {
                        var $clonedItem = $('<li class="placeholder"/>').css({height: cheight});

                        $item.before($clonedItem);

                        $clonedItem.animate({'opacity': 0});

                        $item.animate($clonedItem.position(), function  () {
                            $clonedItem.detach();
                            // $clonedItem.remove();
                            _super($item, container);
                        });
                        //update positions
                        this.reordercol();
                    }.bind(this),

                    // set $item relative to cursor position
                    onDragStart: function ($item, container, _super) {
                        var offset = $item.offset(),
                            pointer = container.rootGroup.pointer;
                        cheight = $item.height();

                        adjustment = pointer.top-offset.top;
                        _super($item, container);
                    },
                    onDrag: function ($item, position,_super) {
                        position.left=-15;
                        position.top-=adjustment;
                        /*$item.css({
                            left: 0,
                            top: position.top - adjustment.top
                        });*/
                        _super($item,position);
                    }
                });
            },
            doAction:function() {
                this.$el.addClass("loading");
                var optsOrig = [];
                for(var i in this.props.models) {
                    optsOrig.push(this.props.models[i].attributes);
                }
                var opts={properties:JSON.parse(JSON.stringify(optsOrig))};
                opts._token=this.opts.get("csrf");
                opts._method="POST";
                $.post(this.opts.get("storeurl"),opts,_.bind(function(response) {
                    if(response.success) {
                        SuccessMessage(response.message);
                        this.$el.removeClass("loading");
                        return;
                    }
                    this.$el.removeClass("loading");
                    alert("Error");
                },this));
                return false;
            },
            processScroll:function() {

                var offset = this.$el.find(".default-properties-list").offset().top - 80;
                if(!this.$el.find(".default-properties-list").closest('#tab_propsex').hasClass("active")) {
                    this.$el.find('.default-properties-list h5').removeClass('active').css("top","0"); return false;
                }

                if(offset < window.scrollY) {
                    requestAnimationFrame(function() {
                        this.$el.find('.default-properties-list h5').addClass('active').css("top", window.scrollY-offset-80 );
                    } .bind(this));
                }else{
                    this.$el.find('.default-properties-list h5').removeClass('active').css("top","0");
                }
            },
            reordercol: function() {
                var norder = 0;
                this.$el.find(".props-table-place-list .super-table-rows .st-row").each(function(i, item){
                    var id = $(item).attr("data-id");
                 //   console.log(id);
                    var m = this.props.get(id);
                 //   console.log(m);
                    if(m) {
                        m.set('order', norder);
                    }
                    norder++;
                }.bind(this));
            }
        });
    });

